import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import ModalRecompensa from "react-modal";
import ModalRecompensaLojinha from "react-modal";
import ModalColaborador from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUpRecompensa from "../../../componente/popup/index.jsx";
import PopUpRecompensaLojinha from "../../../componente/popup/index.jsx";
import PopUpColaborador from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';
import AWS from 'aws-sdk';

function CadDesafio() {
  const { DateTime } = require("luxon");

  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcoddesafio, setedtcoddesafio] = useState(0);
  const [edttitulo, setedttitulo] = useState("");
  const [edtdescricao, setedtdescricao] = useState("");
  const [edtdtlancamento, setedtdtlancamento] = useState("");
  const [edtdtinicio, setedtdtinicio] = useState("");
  const [edtdttermino, setedtdttermino] = useState("");
  const [edtfoto, setedtfoto] = useState("");

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const { codassinante, selectedCompany, accessKey } = useAppContext();

  //campos recompensa
  const [showformrecompensa, setshowformrecompensa] = useState(false);
  const [isOpenRecompensa, setIsOpenRecompensa] = useState(false);
  const [listarecompensa, setlistarecompensa] = useState([]);
  const [listaevento, setlistaevento] = useState([]);
  const [edtcodrecompensadesafio, setedtcodrecompensadesafio] = useState(0);
  const [edtdescricaorecompensadesafio, setedtdescricaorecompensadesafio] = useState("");
  const [edtvalorrealrecompensadesafio, setedtvalorrealrecompensadesafio] = useState(0);
  const [edtvalorcoinrecompensadesafio, setedtvalorcoinrecompensadesafio] = useState(0);
  const [edttiporecompensadesafio, setedttiporecompensadesafio] = useState("");
  const [edtcodeventorecompensadesafio, setedtcodeventorecompensadesafio] = useState(0);

  //campos recompensa lojinha
  const [showformrecompensalojinha, setshowformrecompensalojinha] = useState(false);
  const [isOpenRecompensaLojinha, setIsOpenRecompensaLojinha] = useState(false);
  const [listarecompensalojinha, setlistarecompensalojinha] = useState([]);
  const [listaproduto, setlistaproduto] = useState([]);
  const [edtcodrecompensadesafiolojinha, setedtcodrecompensadesafiolojinha] = useState(0);
  const [edtqtderecompensadesafiolojinha, setedtqtderecompensadesafiolojinha] = useState(0);
  const [edtcodprodutorecompensadesafiolojinha, setedtcodprodutorecompensadesafiolojinha] = useState(0);

  //campos colaborador
  const [showformcolaborador, setshowformcolaborador] = useState(false);
  const [isOpenColaborador, setIsOpenColaborador] = useState(false);
  const [listacolaboradordesafio, setlistacolaboradordesafio] = useState([]);
  const [listaequipe, setlistaequipe] = useState([]);
  const [listasetor, setlistasetor] = useState([]);
  const [listafuncao, setlistafuncao] = useState([]);
  const [listacolaborador, setlistacolaborador] = useState([]);
  const [edtcodcolaboradordesafio, setedtcodcolaboradordesafio] = useState(0);
  const [edtcodcolaborador, setedtcodcolaborador] = useState(0);
  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [edtcodsetor, setedtcodsetor] = useState(0);
  const [edtcodfuncao, setedtcodfuncao] = useState(0);

  // Configuração da AWS
  AWS.config.update({
    accessKeyId: 'AKIAY3NQW3W4IZFQLWC5', // AccountName
    secretAccessKey: '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', // AccountKey
    region: 'us-east-1', // Certifique-se de que esta é a região correta do bucket S3
  });

  const s3 = new AWS.S3();
  const bucketName = 'isolution'; // BucketName

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const params = {
      Bucket: bucketName,
      Key: `iGame/ImagensDesafio/${edttitulo}_${file.name}`, // ObjectName + Nome do Arquivo
      Body: file,
      ContentType: file.type,
      ACL: 'public-read', // Permissão para tornar o arquivo acessível publicamente
    };

    try {
      // Upload para o S3
      const { Location } = await s3.upload(params).promise();
      setedtfoto(Location); // Armazena o link da imagem no estado edtfoto
      alert("Upload realizado com sucesso!");
    } catch (error) {
      console.error('Erro no upload:', error);
      alert("Erro ao realizar o upload.");
    }
  };

  const handleOpen = (cad) => {
    setedtcoddesafio(cad.coddesafio);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    Excluir();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpenRecompensa = (cad) => {
    setedtcodrecompensadesafio(cad.codrecompensadesafio);
    setIsOpenRecompensa(true);
  };

  const handleConfirmaRecompensa = () => {
    setIsOpenRecompensa(false);
    ExcluirRecompensa();
  };

  const handleCloseRecompensa = () => {
    setIsOpenRecompensa(false);
  };

  const handleOpenRecompensaLojinha = (cad) => {
    setedtcodrecompensadesafiolojinha(cad.codrecompensadesafiolojinha);
    setIsOpenRecompensaLojinha(true);
  };

  const handleConfirmaRecompensaLojinha = () => {
    setIsOpenRecompensaLojinha(false);
    ExcluirRecompensaLojinha();
  };

  const handleCloseRecompensaLojinha = () => {
    setIsOpenRecompensaLojinha(false);
  };

  const handleOpenColaborador = (cad) => {
    setedtcodcolaboradordesafio(cad.codcolaboradordesafio);
    setIsOpenColaborador(true);
  };

  const handleConfirmaColaborador = () => {
    setIsOpenColaborador(false);
    ExcluirColaborador();
  };

  const handleCloseColaborador = () => {
    setIsOpenColaborador(false);
  };

  function ListarDesafio() {
    api
      .get("v1/cadastro/desafio", {
        params: {
          busca: abusca,
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(
    function () {
      ListarDesafio();
    },
    [showform, abusca, selectedCompany]
  );

  function ListarRecompensa() {
    api
      .get("/v1/cadastro/desafio/recompensadesafio", {
        params: {
          busca: "",
          coddesafio: edtcoddesafio
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistarecompensa(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarRecompensaLojinha() {
    api
      .get("/v1/cadastro/desafio/recompensadesafio/recompensadesafiolojinha", {
        params: {
          busca: "",
          codrecompensadesafio: edtcodrecompensadesafio
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistarecompensalojinha(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarColaboradorDesafio() {
    api
      .get("/v1/cadastro/desafio/colaboradordesafio", {
        params: {
          busca: "",
          coddesafio: edtcoddesafio
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistacolaboradordesafio(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarEvento() {
    api
      .get("v1/cadastro/evento", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistaevento(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarProduto() {
    api
      .get("v1/cadastro/lojinha", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistaproduto(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarEquipe() {

    api
      .get("/v1/cadastro/equipe", {
        params: {
          busca: "",
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistaequipe(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarSetor() {

    api
      .get("/v1/cadastro/setor", {
        params: {
          busca: "",
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistasetor(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarFuncao() {
    api
      .get("v1/cadastro/funcao", {
        params: {
          busca: "",
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistafuncao(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarColaborador() {
    api
      .get("v1/cadastro/colaborador", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistacolaborador(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/desafio",
        {
          titulo: edttitulo,
          descricao: edtdescricao,
          dtlancamento: edtdtlancamento,
          dtinicio: edtdtinicio,
          dttermino: edtdttermino,
          foto: edtfoto,
          excluido: "N",
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarDesafio();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarRecompensa() {
    api
      .post(
        "v1/cadastro/desafio/recompensadesafio",
        {
          descricao: edtdescricaorecompensadesafio,
          valorreal: edtvalorrealrecompensadesafio,
          valorcoin: edtvalorcoinrecompensadesafio,
          tiporecompensa: edttiporecompensadesafio,
          excluido: "N",
          coddesafio: edtcoddesafio,
          codassinante,
          codempresa: selectedCompany,
          codevento: edtcodeventorecompensadesafio,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(function (response) {
        setedtdescricaorecompensadesafio("");
        setedttiporecompensadesafio("R");
        setedtvalorrealrecompensadesafio(0);
        setedtvalorcoinrecompensadesafio(0);

        setedtcodrecompensadesafio(response.data.codrecompensadesafio);

        ListarRecompensa();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarRecompensaLojinha() {
    api
      .post(
        "/v1/cadastro/desafio/recompensadesafio/recompensadesafiolojinha",
        {
          qtde: edtqtderecompensadesafiolojinha,
          codproduto: edtcodprodutorecompensadesafiolojinha,
          codrecompensadesafio: edtcodrecompensadesafio,
          excluido: "N",
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        setedtqtderecompensadesafiolojinha(0);

        ListarRecompensaLojinha();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarColaboradorMissao0() {
    api
      .post(
        "/v1/cadastro/desafio/colaborador/colaboradorequipedesafio",
        {
          codequipe: edtcodequipe,
          coddesafio: edtcoddesafio,
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarColaboradorDesafio();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarColaboradorMissao1() {
    api
      .post(
        "/v1/cadastro/desafio/colaborador/colaboradorsetordesafio",
        {
          codsetor: edtcodsetor,
          coddesafio: edtcoddesafio,
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarColaboradorDesafio();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarColaboradorMissao2() {
    api
      .post(
        "/v1/cadastro/desafio/colaborador/colaboradorfuncaodesafio",
        {
          codfuncao: edtcodfuncao,
          coddesafio: edtcoddesafio,
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarColaboradorDesafio();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarColaboradorMissao3() {
    api
      .post(
        "/v1/cadastro/desafio/colaboradordesafio",
        {
          codcolaborador: edtcodcolaborador,
          coddesafio: edtcoddesafio,
          codassinante,
          codempresa: selectedCompany,
          excluido: "N"
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarColaboradorDesafio();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/desafio",
        {
          coddesafio: edtcoddesafio,
          titulo: edttitulo,
          descricao: edtdescricao,
          dtinicio: edtdtinicio,
          dttermino: edtdttermino,
          foto: edtfoto,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarDesafio();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/desafio", {
        params: {
          coddesafio: edtcoddesafio,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarDesafio();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirRecompensa() {
    api
      .delete("v1/cadastro/desafio/recompensadesafio", {
        params: {
          codrecompensadesafio: edtcodrecompensadesafio,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarRecompensa();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirRecompensaLojinha() {
    api
      .delete("/v1/cadastro/desafio/recompensadesafio/recompensadesafiolojinha", {
        params: {
          codrecompensadesafiolojinha: edtcodrecompensadesafiolojinha,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarRecompensaLojinha();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirColaborador() {
    api
      .delete("/v1/cadastro/desafio/colaboradordesafio", {
        params: {
          codcolaboradordesafio: edtcodcolaboradordesafio,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarColaboradorDesafio();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function closeModalColaborador() {
    setshowformcolaborador(false);
  }

  function closeModalRecompensa() {
    setshowformrecompensa(false);
  }

  function closeModalRecompensaLojinha() {
    setshowformrecompensalojinha(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcoddesafio(0);
    setedttitulo("");
    setedtdescricao("");

    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let time =
      dt.getHours().toString().padStart(2, "0") +
      ":" +
      dt.getMinutes().toString().padStart(2, "0");
    let dtcadastro = date + "T" + time;

    setedtdtlancamento(dtcadastro);
    setedtdtinicio("");
    setedtdttermino("");
    setedtfoto("");
  }

  function openModalEditar(cad) {
    setshowform(true);
    setnovo(false);

    setedtcoddesafio(cad.coddesafio);
    setedttitulo(cad.titulo);
    setedtdescricao(cad.descricao);

    const dt = DateTime.fromISO(cad.dtlancamento)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd HH:mm");

    setedtdtlancamento(dt);

    const dt1 = DateTime.fromISO(cad.dtinicio)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd HH:mm");

    setedtdtinicio(dt1);

    const dt2 = DateTime.fromISO(cad.dttermino)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd HH:mm");

    setedtdttermino(dt2);
    setedtfoto(cad.foto);
  }

  function openModalRecompensa() {
    setshowformrecompensa(true);

    setedtdescricaorecompensadesafio("");
    setedttiporecompensadesafio("R");
    setedtvalorrealrecompensadesafio(0);
    setedtvalorcoinrecompensadesafio(0);

    ListarRecompensa();
    ListarEvento();
  }

  function openModalProdutoRecompensa() {
    setshowformrecompensalojinha(true);

    ListarProduto();
    setedtqtderecompensadesafiolojinha(0);

    CadastrarRecompensa();
  }

  function openModalColaborador() {
    setshowformcolaborador(true);

    ListarEquipe();
    ListarSetor();
    ListarFuncao();
    ListarColaborador();

    ListarColaboradorDesafio();
  }

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
        .plus({ hours: 3 })
        .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  const handleEventoChange = (event) => {
    setedtcodeventorecompensadesafio(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleProdutoChange = (event) => {
    setedtcodprodutorecompensadesafiolojinha(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleEquipeChange = (event) => {
    setedtcodequipe(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleSetorChange = (event) => {
    setedtcodsetor(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleFuncaoChange = (event) => {
    setedtcodfuncao(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleColaboradorChange = (event) => {
    setedtcodcolaborador(event.target.value); // Armazena "null" para todas as empresas
  };

  return (
    <>
      <div className="app-container">
        <div className="container-fluid">
          <div>
            <div>
              <PopUp isOpen={isOpen} onClose={handleClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse registro?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirma}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleClose}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUp>

              <PopUpRecompensa isOpen={isOpenRecompensa} onClose={handleCloseRecompensa}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir essa recompensa?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaRecompensa}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseRecompensa}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpRecompensa>

              <PopUpRecompensaLojinha isOpen={isOpenRecompensaLojinha} onClose={handleCloseRecompensaLojinha}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse produto da recompensa?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaRecompensaLojinha}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseRecompensaLojinha}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpRecompensaLojinha>

              <PopUpColaborador isOpen={isOpenColaborador} onClose={handleCloseColaborador}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse profissional?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaColaborador}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseColaborador}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpColaborador>
            </div>

            <Modal
              isOpen={showform}
              onRequestClose={closeModal}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Novo Cadastro</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="titulo" className="form-label">
                          Título
                        </label>
                        <input
                          type="text"
                          id="titulo"
                          className="form-control"
                          placeholder="Título"
                          value={edttitulo}
                          onChange={(e) => setedttitulo(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Descrição
                        </label>
                        <input
                          type="text"
                          id="descricao"
                          className="form-control"
                          placeholder="Descrição"
                          value={edtdescricao}
                          onChange={(e) => setedtdescricao(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-4">
                        <label htmlFor="dtlancamento" className="form-label">
                          Dt. Lançamento
                        </label>
                        <input
                          type="datetime-local"
                          id="dtlancamento"
                          className="form-control"
                          placeholder="Dt. Lançamento"
                          value={edtdtlancamento}
                          disabled
                        />
                      </div>

                      <div className="col-sm-4">
                        <label htmlFor="dtinicio" className="form-label">
                          Dt. Início
                        </label>
                        <input
                          type="datetime-local"
                          id="dtinicio"
                          className="form-control"
                          placeholder="Dt. Início"
                          value={edtdtinicio}
                          onChange={(e) => setedtdtinicio(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-4">
                        <label htmlFor="dttermino" className="form-label">
                          Dt. Término
                        </label>
                        <input
                          type="datetime-local"
                          id="dttermino"
                          className="form-control"
                          placeholder="Dt. Término"
                          value={edtdttermino}
                          onChange={(e) => setedtdttermino(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-12">
                        <br />
                        <input type="file" onChange={handleFileUpload} />
                        <p>Link da Foto: <a href={edtfoto} target="_blank" rel="noopener noreferrer">{edtfoto}</a></p>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <div className="col-6 mt-3 d-flex justify-content-start">
                    <button className="btn btn-primary me-4" onClick={openModalRecompensa} disabled={novo}>
                      Recompensa
                    </button>
                    <button className="btn btn-primary me-4" onClick={openModalColaborador} disabled={novo}>
                      Profissional
                    </button>
                  </div>

                  <div className="col-6 mt-3 d-flex justify-content-end">
                    <button className="btn btn-danger ms-4" onClick={closeModal}>
                      Cancelar
                    </button>
                    <button className="btn btn-success ms-4" onClick={Salvar}>
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </Modal>

            <ModalColaborador
              isOpen={showformcolaborador}
              onRequestClose={closeModalColaborador}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Profissionais do desafio: {edttitulo}</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-8">
                        <label htmlFor="titulo" className="form-label">
                          Equipe
                        </label>
                        <select className="form-select" value={edtcodequipe || '0'} onChange={handleEquipeChange}>
                          <option value="0">Selecione a equipe</option>
                          {listaequipe.map((eq, index) => (
                            <option key={index} value={eq.codequipe}>{eq.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-4">
                        <button type="button" className="btn btn-primary h-100 w-100" onClick={CadastrarColaboradorMissao0}>
                          Adicionar Profissionais da equipe
                        </button>
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <hr />
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-8">
                        <label htmlFor="setor" className="form-label">
                          Setor
                        </label>
                        <select className="form-select" value={edtcodsetor || '0'} onChange={handleSetorChange}>
                          <option value="0">Selecione o setor</option>
                          {listasetor.map((set, index) => (
                            <option key={index} value={set.codsetor}>{set.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-4">
                        <button type="button" className="btn btn-primary h-100 w-100" onClick={CadastrarColaboradorMissao1}>
                          Adicionar Profissionais do Setor
                        </button>
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <hr />
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-8">
                        <label htmlFor="funcao" className="form-label">
                          Função
                        </label>
                        <select className="form-select" value={edtcodfuncao || '0'} onChange={handleFuncaoChange}>
                          <option value="0">Selecione a função</option>
                          {listafuncao.map((fun, index) => (
                            <option key={index} value={fun.codfuncao}>{fun.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-4">

                        <button type="button" className="btn btn-primary h-100 w-100" onClick={CadastrarColaboradorMissao2}>
                          Adicionar Profissionais da Função
                        </button>
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <hr />
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-8">
                        <label htmlFor="colaborador" className="form-label">
                          Profissional
                        </label>
                        <select className="form-select" value={edtcodcolaborador || '0'} onChange={handleColaboradorChange}>
                          <option value="0">Selecione o profissional</option>
                          {listacolaborador.map((col, index) => (
                            <option key={index} value={col.codcolaborador}>{col.nome}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-4">
                        <button type="button" className="btn btn-primary h-100 w-100" onClick={CadastrarColaboradorMissao3}>
                          Adicionar Profissional
                        </button>
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <hr />
                    </div>
                  </form>
                </div>

                <div className="row">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Profissional</th>
                        <th>Aceito</th>
                        <th>Concluído</th>
                        <th className="acao">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listacolaboradordesafio.map(function (item) {
                        return (
                          <tr key={item.codcolaboradordesafio}>
                            <th>{item.colaborador}</th>
                            <th>{item.aceito}</th>
                            <th>{item.concluiu}</th>
                            <th>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn fa-solid fa-trash"
                                  onClick={() => handleOpenColaborador(item)}
                                ></button>
                              </div>
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={4}>Quantidade de Registros: {listacolaboradordesafio.length}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button className="btn btn-danger ms-4" onClick={closeModalColaborador}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalColaborador>

            <ModalRecompensa
              isOpen={showformrecompensa}
              onRequestClose={closeModalRecompensa}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Recompensas do desafio: {edttitulo}</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Descrição
                        </label>
                        <input
                          type="text"
                          id="descricao"
                          className="form-control"
                          placeholder="Descrição"
                          value={edtdescricaorecompensadesafio}
                          onChange={(e) => setedtdescricaorecompensadesafio(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-4">
                        <label htmlFor="evento" className="form-label">
                          Evento
                        </label>
                        <select className="form-select" value={edtcodeventorecompensadesafio || '0'} onChange={handleEventoChange}>
                          <option value="0">Selecione o evento</option>
                          {listaevento.map((eve, index) => (
                            <option key={index} value={eve.codevento}>{eve.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="tiporecompensa" className="form-label">
                          Tipo de Recompensa
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="tiporecompensa"
                            type="radio"
                            name="tiporecompensa"
                            value="R"
                            onChange={(e) => setedttiporecompensadesafio(e.target.value)}
                            checked={edttiporecompensadesafio === "R"}
                          />
                          <label className="form-check-label">Valor em Real</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tiporecompensa"
                            value="C"
                            onChange={(e) => setedttiporecompensadesafio(e.target.value)}
                            checked={edttiporecompensadesafio === "C"}
                          />
                          <label className="form-check-label">Valor em Coin</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tiporecompensa"
                            value="P"
                            onChange={(e) => setedttiporecompensadesafio(e.target.value)}
                            checked={edttiporecompensadesafio === "P"}
                          />
                          <label className="form-check-label">Produto</label>
                        </div>
                      </div>
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-3">
                        <label htmlFor="valorreal" className="form-label">
                          Valor em Real
                        </label>
                        <input
                          type="number"
                          id="valorreal"
                          className="form-control"
                          placeholder="Valor em Real"
                          value={edtvalorrealrecompensadesafio}
                          onChange={(e) => setedtvalorrealrecompensadesafio(e.target.valueAsNumber)}
                          disabled={edttiporecompensadesafio === 'C' || edttiporecompensadesafio === 'P'}
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="valorcoin" className="form-label">
                          Valor em Coin
                        </label>
                        <input
                          type="number"
                          id="valorcoin"
                          className="form-control"
                          placeholder="Valor em Coin"
                          value={edtvalorcoinrecompensadesafio}
                          onChange={(e) => setedtvalorcoinrecompensadesafio(e.target.valueAsNumber)}
                          disabled={edttiporecompensadesafio === 'R' || edttiporecompensadesafio === 'P'}
                        />
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" disabled={edttiporecompensadesafio === 'R' || edttiporecompensadesafio === 'C'}
                          onClick={openModalProdutoRecompensa}>
                          Adicionar Produto
                        </button>
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" onClick={CadastrarRecompensa}>
                          Adicionar Recompesa
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th>Tipo Recompensa</th>
                        <th>Real</th>
                        <th>Coin</th>
                        <th>Produtos</th>
                        <th className="acao">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listarecompensa.map(function (item) {
                        return (
                          <tr key={item.codrecompensadesafio}>
                            <th>{item.descricao}</th>
                            <th>{item.tiporecompensa}</th>
                            <th>{item.valorreal}</th>
                            <th>{item.valorcoin}</th>
                            <th>{item.produtos}</th>
                            <th>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn fa-solid fa-trash"
                                  onClick={() => handleOpenRecompensa(item)}
                                ></button>
                              </div>
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={6}>Quantidade de Registros: {listarecompensa.length}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button type="button" className="btn btn-danger ms-4" onClick={closeModalRecompensa}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalRecompensa>

            <ModalRecompensaLojinha
              isOpen={showformrecompensalojinha}
              onRequestClose={closeModalRecompensaLojinha}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Produtos da recompensa do desafio: {edtdescricaorecompensadesafio}</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="produto" className="form-label">
                          Produto
                        </label>
                        <select className="form-select" value={edtcodprodutorecompensadesafiolojinha || '0'} onChange={handleProdutoChange}>
                          <option value="0">Selecione o produto</option>
                          {listaproduto.map((pro, index) => (
                            <option key={index} value={pro.codproduto}>{pro.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="qtde" className="form-label">
                          Qtde
                        </label>
                        <input
                          type="number"
                          id="qtde"
                          className="form-control"
                          placeholder="Qtde"
                          value={edtqtderecompensadesafiolojinha}
                          onChange={(e) => setedtqtderecompensadesafiolojinha(e.target.valueAsNumber)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" onClick={CadastrarRecompensaLojinha}>
                          Adicionar Produto
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Produto</th>
                        <th>Qtde</th>
                        <th className="acao">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listarecompensalojinha.map(function (item) {
                        return (
                          <tr key={item.codrecompensadesafiolojinha}>
                            <th>{item.produto}</th>
                            <th>{item.qtde}</th>
                            <th>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn fa-solid fa-trash"
                                  onClick={() => handleOpenRecompensaLojinha(item)}
                                ></button>
                              </div>
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={3}>Quantidade de Registros: {listarecompensalojinha.length}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button type="button" className="btn btn-danger ms-4" onClick={closeModalRecompensaLojinha}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalRecompensaLojinha>
          </div>

          <div className="row">
            <h1 className="ms-4">Cadastro de Desafios</h1>
            <p className="ms-4">Rotina para cadastrar os desafios que os profissionais irão participar</p>
            <hr />
          </div>

          <div className="row">
            <div className="col-10">
              <label className="d-block" htmlFor="busca">
                Busque aqui
              </label>
              <input
                type="text"
                placeholder="Buscar por: Código ou título"
                name="busca"
                id="busca"
                className="form-control me-3"
                value={abusca}
                onChange={(e) => setabusca(e.target.value)}
              />
            </div>
            <div className="col-2 d-flex justify-content-center">
              <button
                className="btn btn-success btnnovo"
                onClick={() => openModalNovo()}
              >
                Novo
              </button>
            </div>
          </div>

          <div className="row mt-3">
            <hr />
          </div>

          <div className="row">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Título</th>
                  <th>Descrição</th>
                  <th>Dt. Lançamento</th>
                  <th>Dt. Início</th>
                  <th>Dt. Término</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {lista.map(function (item) {
                  return (
                    <tr key={item.coddesafio}>
                      <th>{item.coddesafio}</th>
                      <th>{item.titulo}</th>
                      <th>{item.descricao}</th>
                      <th>{FormataDataHora(item.dtlancamento)}</th>
                      <th>{FormataDataHora(item.dtinicio)}</th>
                      <th>{FormataDataHora(item.dttermino)}</th>
                      <th>
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn fa-regular fa-pen-to-square"
                            onClick={() => openModalEditar(item)}
                          ></button>
                          <button
                            className="btn fa-solid fa-trash"
                            onClick={() => handleOpen(item)}
                          ></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={7}>Quantidade de Registros: {lista.length}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CadDesafio;
